/**
 * Multiplies values
 * @param values values to be multiplied
 * @returns Multiplication of values
 */
export function hbsHelperMul(...values: any): number {
  const filtered = values.filter(x => !isNaN(parseFloat(x)) && isFinite(x));
  return filtered.reduce((a, b) => a + b, 1);
}